<ui-modal
  class="entities-modal"
  [isOpened]="modalOpen"
  modalTitle="Currency Pairs"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="currency-pairs">
    <table ui-table>
      <thead>
        <tr>
          <th>Currency Pair</th>
          <th>Spot Convention</th>
          <th>Forward Points Multiplier</th>
          <th>Default Premium Currency</th>
          <th>BS Delta</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pair of currencyPairs">
          <td>{{ pair.currencyPair }}</td>
          <td>{{ pair.spotConvention }}</td>
          <td>{{ pair.forwardPointsMultiplier | number: '1.0-0' }}</td>
          <td>{{ pair.defaultPremiumCurrency }}</td>
          <td>{{ pair.lastSpotDeltaQuotedTenor }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ui-modal>
